import qs from 'query-string';

import {
  API_ENDPOINT,
  type ClientApiV2VouchersMyQueryString,
  useClientApiV2VouchersMyQuery,
} from '../../../../../../resources/@types/courseSchema';
import type { NormalizeObject, StringifyObject } from '../../../../../utils/typeUtil';

export type VoucherMyQueryParameter = NormalizeObject<ClientApiV2VouchersMyQueryString>;

export function useClientApiVoucherMyQuery({
  query,
  options,
}: {
  query: StringifyObject<VoucherMyQueryParameter>;
  options?: Parameters<typeof useClientApiV2VouchersMyQuery>[0]['options'];
}) {
  return useClientApiV2VouchersMyQuery({
    url: qs.stringifyUrl(
      {
        url: API_ENDPOINT.CLIENT_V2_VOUCHERS_MY,
        query,
      },
      {
        skipEmptyString: true,
      },
    ),
    queryKey: getUseClientApiVoucherMyQueryQueryKey(query),
    options,
  });
}

function getUseClientApiVoucherMyQueryQueryKey(query: StringifyObject<VoucherMyQueryParameter>) {
  return [API_ENDPOINT.CLIENT_V2_VOUCHERS_MY, query];
}

export const useClientApiVouchersMyQueryRootResetKey = [API_ENDPOINT.CLIENT_V2_VOUCHERS_MY];
